import { last } from "radashi";
import { engine } from "..";
import { trackLiveObjects } from "../helpers/trackLiveObjects";
import { withDelete } from "../helpers/withDelete";
import { QualifiedId } from "../products/types";
import { createQualifiedIdVector, toArray } from "../vector";
import { asQualifiedId } from "./helpers";

export const directSelectionRepository = trackLiveObjects(
  "directSelectionRepository",
  {
    applySelection(
      selectionType: "select" | "unselect",
      productId: QualifiedId,
      alreadySelected: QualifiedId[],
      workWithDeleted: boolean,
    ) {
      const directSelection = new engine.DirectSelection();
      const engineProductId = new engine.QualifiedId(
        productId.id,
        productId.type,
      );
      const currentSelection = createQualifiedIdVector(
        alreadySelected.map(({ id, type }) => new engine.QualifiedId(id, type)),
      );
      const results = withDelete(
        [engineProductId, currentSelection],
        directSelection[selectionType](
          engineProductId,
          currentSelection,
          workWithDeleted,
        ),
      );

      if (!results) {
        return withDelete(directSelection, {
          disabledIds: [],
          selectedIds: [],
        });
      }

      return withDelete(directSelection, {
        disabledIds: toArray(results.disabledIds).map((id) =>
          withDelete(id, asQualifiedId(id)),
        ),
        selectedIds: toArray(results.selectedIds).map((id) =>
          withDelete(id, asQualifiedId(id)),
        ),
      });
    },

    getDisabledIds(selection: QualifiedId[]) {
      const lastSelection = last(selection);
      return lastSelection
        ? directSelectionRepository.select(lastSelection, selection, false)
            .disabledIds
        : [];
    },

    select(
      productId: QualifiedId,
      alreadySelected: QualifiedId[],
      workWithDeleted: boolean,
    ) {
      return directSelectionRepository.applySelection(
        "select",
        productId,
        alreadySelected,
        workWithDeleted,
      );
    },

    unselect(
      productId: QualifiedId,
      alreadySelected: QualifiedId[],
      workWithDeleted: boolean,
    ) {
      return directSelectionRepository.applySelection(
        "unselect",
        productId,
        alreadySelected,
        workWithDeleted,
      );
    },
  },
);
